<template>
	<div class="app-container">
		<div class="center_part">
			<div class="logo">
				<img src="../assets/images/logo.png" alt=""/>
			</div>
			<div class="serviceInfo clearfix">
				<div class="serviceInfo_left f-left clearfix">
					<img class="f-left" src="../assets/images/avatar.png" alt=""/>
					<div class="f-left" v-if="!delTalkFlag">
						客服：{{ hasService ? curUser.userNickName : "正在为您分配客服" }}
					</div>
					<div class="f-left" v-else>客服：已断开连接，如需咨询，请重新分配。</div>
				</div>
				<div class="serviceInfo_right f-right">
					<!--					<el-button-->
					<!--						style="-->
					<!--              width: 100px;-->
					<!--              height: 30px;-->
					<!--              background: #2697a2;-->
					<!--              opacity: 1;-->
					<!--              border-radius: 20px;-->
					<!--              padding: 0px;-->
					<!--              color: #fff;-->
					<!--            "-->
					<!--						v-if="!delTalkFlag"-->
					<!--						@click="delTalk"-->
					<!--					>结束对话-->
					<!--					</el-button>-->
					<el-button
						style="
              width: 100px;
              height: 30px;
              background: #2697a2;
              opacity: 1;
              border-radius: 20px;
              padding: 0px;
              color: #fff;
            "
						v-if="delTalkFlag"
						:disabled="curUser.isWait === 'Y'"
						@click="reLinkService"
					>分配对话
					</el-button>
				</div>
			</div>
			<div class="chatWrap" id="chatWrap" ref="chatWrap" @scroll="deOnScroll">
				<div class="waitTip" v-if="!hasService && !delTalkFlag">
					正在分配客服中, 请耐心等待……
				</div>
				<div class="waitTip" v-else-if="hasService && !delTalkFlag">
					已为您分配客服{{ curUser.userNickName }}
				</div>
				<div class="waitTip" v-else-if="!hasService && delTalkFlag">
					当前会话已结束，如需咨询，请重新分配!
				</div>
				<div
					class="chatItem"
					v-for="(item, i) in sessionsList"
					:key="item.idClient"
					:ref="item.idClient"
					:class="[
            item.from !== curUserInfo.accid ? 'chatInStyle' : 'chatOutStyle',
          ]"
					@contextmenu="contextmenu1(i)"
				>
					<div v-if="item.type === 'text'">
						<div class="chatIn clearfix" v-if="item.from !== curUserInfo.accid">
							<img class="f-left" src="../assets/images/avatar.png" alt=""/>
							<div class="chatContent f-left">
								{{ item.text }}
								<div class="sanjiao f-right"></div>
								<div class="time">
									<span>{{ parseTime(item.time) }}</span>
								</div>
							</div>
						</div>
						<div class="chatOut clearfix" v-else>
							<img class="f-right" :src="curUserInfo.icon" alt=""/>
							<div class="chatContent f-right">
								{{ item.text }}
								<div class="sanjiao f-right"></div>
								<div class="time">
									<span v-html="getMsgDeviceId(item)"></span>
									<span>{{ parseTime(item.time) }}</span>
								</div>
							</div>
						</div>
					</div>
					<div v-else-if="item.type === 'image'">
						<div class="chatIn clearfix" v-if="item.from !== curUserInfo.accid">
							<img class="f-left" src="../assets/images/avatar.png" alt=""/>
							<div class="chatContent f-left">
								<img
									class="chatImg"
									:src="item.file.url"
									alt=""
									@click="goImgUrl(item.file.url)"
								/>
								<div class="sanjiao f-left"></div>
								<div class="time">
									<span>{{ parseTime(item.time) }}</span>
								</div>
							</div>
						</div>
						<div class="chatOut clearfix" v-else>
							<img class="f-right" :src="curUserInfo.icon" alt=""/>
							<div class="chatContent f-right">
								<img
									class="chatImg"
									:src="item.file.url"
									alt=""
									@click="goImgUrl(item.file.url)"
								/>
								<div class="sanjiao f-right"></div>
								<div class="time">
									<span v-html="getMsgDeviceId(item)"></span>
									<span>{{ parseTime(item.time) }}</span>
								</div>
							</div>
						</div>
					</div>
					<div
						v-else-if="
              item.type === 'file' ||
              item.type === 'video' ||
              item.type === 'audio'
            "
					>
						<div
							v-if="
                item.file.ext === 'mp4' ||
                item.file.ext === 'mp3' ||
                item.file.ext === 'avi' ||
                item.file.ext === 'mkv'
              "
						>
							<div class="chatIn clearfix" v-if="item.from !== curUserInfo.accid">
								<img class="f-left" src="../assets/images/avatar.png" alt=""/>
								<div class="chatContent f-left">
									<video
										style="width: 200px; height: 100px;"
										:src="item.file.url"
										controls="controls"
									></video>
									<div class="sanjiao f-left"></div>
									<div class="time">
										<span>{{ parseTime(item.time) }}</span>
									</div>
								</div>
							</div>
							<div class="chatOut clearfix" v-else>
								<img class="f-right" :src="curUserInfo.icon" alt=""/>
								<div class="chatContent f-right">
									<video
										style="width: 200px; height: 100px;"
										:src="item.file.url"
										controls="controls"
									></video>
									<div class="sanjiao f-right"></div>
									<div class="time">
										<span v-html="getMsgDeviceId(item)"></span>
										<span>{{ parseTime(item.time) }}</span>
									</div>
								</div>
							</div>
						</div>
						<div v-else-if="
                item.file.ext === 'png' ||
                item.file.ext === 'jpg' ||
                item.file.ext === 'jepg'
              "
						>
							<div class="chatIn clearfix" v-if="item.from !== curUserInfo.accid">
								<img class="f-left" src="../assets/images/avatar.png" alt=""/>
								<div class="chatContent f-right">
									<img
										class="chatImg"
										:src="item.file.url"
										alt=""
										@click="goImgUrl(item.file.url)"
									/>
									<div class="sanjiao f-left"></div>
									<div class="time">
										<span>{{ parseTime(item.time) }}</span>
									</div>
								</div>
							</div>
							<div class="chatOut clearfix" v-else>
								<img class="f-right" :src="curUserInfo.icon" alt=""/>
								<div class="chatContent f-left">
									<img
										class="chatImg"
										:src="item.file.url"
										alt=""
										@click="goImgUrl(item.file.url)"
									/>
									<div class="sanjiao f-right"></div>
									<div class="time">
										<span v-html="getMsgDeviceId(item)"></span>
										<span>{{ parseTime(item.time) }}</span>
									</div>
								</div>
							</div>
						</div>
						<div v-else>
							<div class="chatIn clearfix" v-if="item.from !== curUserInfo.accid">
								<img class="f-left" src="../assets/images/avatar.png" alt=""/>
								<div class="chatContent f-left">
									<img
										src="../assets/images/file.png"
										alt=""
										style="width: 43px; height: 60px; margin-right: 10px;"
										@click="goFile(item.file)"
									/>
									<div>{{ item.file.name }}</div>
									<div class="sanjiao f-left"></div>
									<div class="time">
										<span>{{ parseTime(item.time) }}</span>
									</div>
								</div>
							</div>
							<div class="chatOut clearfix" v-else>
								<img class="f-right" :src="curUserInfo.icon" alt=""/>
								<div class="chatContent f-right">
									<img
										src="../assets/images/file.png"
										alt=""
										style="width: 43px; height: 60px; margin-right: 10px;"
										@click="goFile(item.file)"
									/>
									<div>{{ item.file.name }}</div>
									<div class="sanjiao f-right"></div>
									<div class="time">
										<span v-html="getMsgDeviceId(item)"></span>
										<span>{{ parseTime(item.time) }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-else-if="item.type === 'offline'" class="chat-notify">
						<span>客服暂时不在线，您可以先留言，客服上线后会尽快为您解答哦</span>
					</div>
					<div v-else-if="item.type === 'online'" class="chat-notify">
						<span>客服已上线</span>
					</div>
				</div>
			</div>
			<div class="files">
				<template v-for="p in progressFiles">
					<article class="file-progress-cont">
						<el-progress :format="getProgressText(p)"
									 :percentage="p.percentage"
									 :stroke-width="20"
									 text-inside></el-progress>
					</article>
				</template>
			</div>
			<div class="chatFunBtn">
				<img
					src="../assets/images/chatfunbtn3.png"
					alt=""
					style="height: 18px;width: 18px;"
					@click="showEmoji = !showEmoji"
				/>
				<img
					src="../assets/images/chatfunbtnfile.png"
					v-if="showSendImage"
					style="height: 18px;width: 22px;"
					@click="handleSendFile"
				/>
				<input
					class="fileselect"
					type="file"
					id="fileselect"
					@change="uploadFile"
				/>
				<img
					src="../assets/images/chatfunbtn6.png"
					alt=""
					style="height: 18px;width: 18px;"
					@click="handleUserRate"
				/>
				<div class="emojiWrap clearfix" v-show="showEmoji">
					<div
						class="emojiItem f-left"
						v-for="(item, i) in rightList"
						:key="i"
						@click="handleClickEmoji(item.icon)"
					>
						{{ item.icon }}
					</div>
				</div>
			</div>
			<div class="chatInputWrap clearfix">
				<el-input
					id="chatInput" v-model="chatValue"
					type="textarea" rows="5"
					style="font-weight: 600;" resize="none"
					class="f-left chatInputInput"
					@focus="handleClickInput"
				></el-input>
				<el-button class="send-btn f-left" style="margin-left: 20px;" type="primary"
						   @click="sendText">发送
				</el-button>
			</div>
			<div class="rateDialog" v-show="showRate">
				<div class="cancel" @click="closeRate">X</div>
				<div class="rateTitle">在线评分</div>
				<div class="rateTip">
					尊敬的客户，您好：希望您对本次沟通做出评价，感谢您！
				</div>
				<div class="rateBox">
					<el-rate v-model="rateScore"></el-rate>
				</div>
				<div class="rateContent">
					<el-input
						type="textarea"
						:rows="3"
						placeholder="请输入内容"
						v-model="rateContent"
						style="width: 100%;">
					</el-input>
				</div>
				<el-button
					style="
            background: #2697a2;
            width: 200px;
            color: #fff;
            margin-left: 137px;
          "
					@click="handleRate"
				>提交
				</el-button
				>
			</div>
		</div>
		<vue-context-menu
			ref="contextMenu"
			:contextMenuData="contextMenuData1"
			@delMsg="delMsg">
			<li class="menu-item" @click="delMsg">
				<i></i>
				撤回消息
			</li>
		</vue-context-menu>
		<el-dialog title="连接已断开"
				   :visible.sync="offline.show"
				   width="25rem"
				   top="33vh"
				   :close-on-click-modal="false"
				   :show-close="false"
				   :close-on-press-escape="false"
				   center>
			<span v-text="offline.title"></span>
		</el-dialog>

	</div>
</template>

<script>
import { sizeFormatter } from "human-readable";
import NIM from "../utils/NIM_Web_NIM_v8.1.0"; // 引用的im sdk
import { emoji } from "../utils/biaoqing.js";
import vueContextMenu from "vue-context-menu";
import {
	addBatch,
	checkRateRes,
	close,
	cloudRate,
	getCloudServiceInfo,
	getCurCloudUserInfo,
	getLoginTokenById,
	getRecordsReverseOrder,
	heartBeat,
	sendMsgToServerCheckOverTime,
} from "@/request/api";
import { mapServerMsgToYunXin } from "@/utils/common.js";
import { Base64 } from "js-base64";
import UAParser from "ua-parser-js";
import _ from "lodash-es";
import moment from "moment";

const sizeFormat = sizeFormatter({
	std: "JEDEC", // 'SI' (default) | 'IEC' | 'JEDEC'
	decimalPlaces: 2,
	keepTrailingZeroes: true,
	render: (literal, symbol) => `${literal} ${symbol}B`,
});

import { blink, checkNotificationStatus, requestNotifyPermission, showNotification } from "../utils/notifier.js";

export default {
	data() {
		return {
			nim: null,
			inputvalue: "",
			input1: "",
			chatValue: "",
			activeName: "1",
			activeName1: "1",
			sessionsList: [], // 聊天信息
			scene: "p2p", // 聊天模式 单聊模式p2p
			text: "", // 发送的文字信息
			toUserImg: "",
			toUserName: "",
			toAccount: "", // 给发送的人id
			errMsg: "", // 不能为空消息
			showErrMsg: false, // 发送错误信息模板
			dataList: {
				sessions: [],
			},
			offline: {
				show: false,
				title: "",
			},
			sensitiveList: [],
			curUser: {},
			initFlage: true,
			serviceInfo: {},
			noticeList: [],
			title: "",
			openNotice: false,
			noticeDetail: "",
			replyList: [],
			chatTxtList: [],
			emojiList: [],
			rightList: [],
			showEmoji: false,
			chatRecordDate: [],
			chatRecordImgList: [],
			curUserInfo: {},
			hasService: false,
			showRate: false,
			rateScore: null,
			rateContent: "",
			secretKey: "Bear321",
			delTalkFlag: false,
			rateRes: {},
			contextMenuData1: {
				axis: {
					x: null,
					y: null,
				},
			},
			delMsgIndex: null,
			showSendImage: false,
			paging: {
				pageNum: 1,
				pageSize: 50,
				total: 0,
				allData: false,
			},
			lastMsg: undefined,
			deOnScroll: undefined,
			deCheckCsrIsOffline: undefined,
			progressFiles: [],
		};
	},
	created() {
		this.emojiList = [
			emoji[1],
			emoji[2],
			emoji[3],
			emoji[4],
			emoji[5],
			emoji[7],
			emoji[8],
		];

		const _self = this;
		document.onkeydown = function (e) {
			const key = window.event.keyCode;
			if (key === 13 && _self.hasService) {
				_self.sendText();
			}
		};
		this.emojiList.forEach((item) => {
			item.iconArr.forEach((item1) => {
				this.rightList.push(item1);
			});
		});
		this.handleLoginById();
	},
	mounted() {
		this.deOnScroll = _.debounce(this.onMsgScroll, 100);
		this.deCheckCsrIsOffline = _.debounce(this.checkCsrIsOffline, 1000, {
			trailing: true,
		});
	},
	updated() {

	},
	methods: {
		/**
		 * 消息滚动
		 */
		onMsgScroll(e) {
			if (e.target.scrollTop > 200) {
				return;
			}
			if (this.paging.allData) {
				return;
			}
			this.paging.pageNum += 1;
			this.getHistoryMsgsById(this.nim.account);
		},
		/**
		 * 根据云信用户Id获取历史消息
		 * @param csId 云信用户Id
		 */
		getHistoryMsgsById(csId) {
			if (!this.hasService) {
				return;
			}
			const p = this.paging;
			const firstItem = _.first(this.sessionsList);
			const idClient = !!firstItem ? firstItem.idClient : undefined;
			return getRecordsReverseOrder(csId, p.pageNum, p.pageSize).then(history => {
				this.paging.total = history.total;
				const msgs = history.rows;
				if (!msgs || msgs.length === 0) {
					this.paging.allData = true;
				}
				const yxMsgs = mapServerMsgToYunXin(msgs);
				if (this.paging.pageNum == 1) {
					this.sessionsList = yxMsgs.reverse();
				} else {
					this.sessionsList = yxMsgs.reverse().concat(this.sessionsList);
				}

				if (idClient) {
					this.$nextTick().then(() => {
						const chatWrap = document.getElementById("chatWrap");
						const element = this.$refs[idClient][0];
						chatWrap.scrollTo({
							top: element.offsetTop,
							behavior: "instant",
						})
					});
				}
			});
		},
		/**
		 * 发送心跳包
		 */
		sendHeartBeat() {
			console.log("发送心跳包");
			heartBeat();
		},
		/**
		 * 获取token
		 */
		handleLoginById() {
			getLoginTokenById({ username: this.$route.query.id }).then((res) => {
				if (res.code === 200) {
					sessionStorage.setItem("token", res.token);
					this.getCurUserInfo();
				}
			});
		},
		/**
		 * 获取当前用户云信登录信息
		 */
		getCurUserInfo() {
			getCurCloudUserInfo().then((res) => {
				if (res.code === 200) {
					this.init(res.data);
					this.curUserInfo = res.data;
					if (!this.curUserInfo.icon) {
						this.curUserInfo.icon = require("../assets/images/myavatar.png");
					}
				}
			});
			setInterval(this.sendHeartBeat, 60000);
		},
		/**
		 * 分配客服
		 */
		cloudServiceInfo() {
			const params = {
				customerAccid: this.curUserInfo.accid,
				customerSource: "web",
			};
			getCloudServiceInfo(params).then((res) => {
				if (res.code === 200) {
					this.cloudServiceResponse(res.data);
				} else {
					alert(`[E3871]分派客服失败，请稍后重试：${res.code}`);
				}
			});
		},
		/**
		 * 处理分派客服返回
		 * @param data 数据
		 */
		cloudServiceResponse(data) {
			this.curUser = data;
			if (data.isWait === "Y") {
				this.hasService = false;
				setTimeout(() => {
					this.cloudServiceInfo();
				}, 5000);
				return;
			}
			try {
				this.hasService = true;
				this.delTalkFlag = false;
				this.paging.pageNum = 1;
				this.paging.allData = false;
				this.getHistoryMsgsById(this.nim.account).then(() => {
					this.$nextTick().then(this.scrollBottom);
				});
				const storageId = `session-${this.curUser.sessionId}`;
				if (!localStorage.getItem(storageId)) {
					let content = {
						type: "start",
						sessionId: this.curUser.sessionId,
					};
					content = JSON.stringify(content);
					var msgId = this.nim.sendCustomMsg({
						scene: "p2p",
						to: this.curUser.userAccid,
						content: content,
						sendToOnlineUsersOnly: true,
						apnsText: content,
						done: this.sendMsgDone,
					});
				}
				const that = this;
				this.nim.subscribeEvent({
					type: 1,
					accounts: [this.curUser.userAccid],
					subscribeTime: 86400,
					sync: true,
					done(error, obj) {
						console.log("订阅事件" + (!error ? "成功" : "失败"), error, obj);
						that.deCheckCsrIsOffline();
					},
				});
				localStorage.setItem(storageId, "true");
				console.log("发送开始会话", msgId);
				this.nim.getUser({
					account: this.curUserInfo.accid.toLowerCase(),
					done: this.getUserDone,
				});
				if (this.curUser.userAccid) {
					this.nim.setCurrSession("p2p-" + this.curUser.userAccid.toLowerCase());
				}
			} catch (e) {
				alert(`[E3875]分派客服失败，请稍后重试：${JSON.stringify(e)}`);
			}
		},
		/**
		 * 检查客服是否在线
		 */
		checkCsrIsOffline() {
			if (!window.onlineInfo) {
				window.onlineInfo = {};
				window.lastOnlineInfo = {};
			}
			const accid = this.curUser.userAccid;
			const ol = window.onlineInfo[accid];
			const lastStatus = window.lastOnlineInfo[accid];
			const isOnline = ol && ol.isOnline;

			if (!!lastStatus && isOnline === lastStatus) {
				return;
			}

			if (isOnline) {
				if (lastStatus !== undefined) {
					this.sessionsList.push({
						"type": "online",
					});
				}
			} else {
				this.sessionsList.push({
					"type": "offline",
				});
			}
			window.lastOnlineInfo[accid] = isOnline;
			this.scrollBottom();
		},
		/**
		 * 关闭评分
		 */
		closeRate() {
			this.showRate = false;
			this.rateScore = null;
			this.rateContent = "";
		},
		/**
		 * 评分
		 */
		handleRate() {
			if (this.rateScore === 0) {
				alert("请选择评分！");
			} else {
				const params = {
					sessionIdStr: this.curUser.sessionId,
					sessionScore: this.rateScore,
					scoreContent: this.rateContent,
				};
				const str = new URLSearchParams(Object.entries(params)).toString();
				cloudRate(str).then((res) => {
					if (res.code === 200) {
						alert("感谢您的评分，祝您生活愉快！");
						this.closeRate();
						let content = {
							type: "rate",
							sessionId: this.curUser.sessionId,
						};
						content = JSON.stringify(content);
						const msgId = this.nim.sendCustomMsg({
							scene: "p2p",
							to: this.curUser.userAccid,
							content: content,
							sendToOnlineUsersOnly: true,
							apnsText: content,
							done: this.sendMsgDone,
						});
					}
				});
			}
		},
		/**
		 * 初始化
		 * @param data 数据
		 */
		init(data) {
			this.nim = new NIM({
				// 初始化SDK
				// debug: true
				appKey: "cf1bf99b757478fb3686fd7a452bb41c",
				account: data.accid.toLowerCase(),
				token: data.token,
				syncSessionUnread: true,
				db: false,
				syncRoamingMsgs: true,
				onconnect: this.onConnect,
				onerror: this.onError,
				onwillreconnect: this.onWillReconnect,
				ondisconnect: this.onDisconnect,
				// 多端
				onloginportschange: this.onLoginPortsChange,
				// 用户关系
				onblacklist: this.onBlacklist,
				onsyncmarkinblacklist: this.onMarkInBlacklist,
				onmutelist: this.onMutelist,
				onsyncmarkinmutelist: this.onMarkInMutelist,
				// 好友关系
				onfriends: this.onFriends,
				onsyncfriendaction: this.onSyncFriendAction,
				// 用户名片
				onmyinfo: this.onMyInfo,
				onupdatemyinfo: this.onUpdateMyInfo,
				onusers: this.onUsers,
				onupdateuser: this.onUpdateUser,

				// 会话
				onsessions: this.onSessions,
				onupdatesession: this.onUpdateSession,
				// 消息
				onroamingmsgs: this.onRoamingMsgs,
				onofflinemsgs: this.onOfflineMsgs,
				onmsg: this.onMsg,
				// 系统通知
				onofflinesysmsgs: this.onOfflineSysMsgs,
				onsysmsg: this.onSysMsg,
				onupdatesysmsg: this.onUpdateSysMsg,
				onsysmsgunread: this.onSysMsgUnread,
				onupdatesysmsgunread: this.onUpdateSysMsgUnread,
				onofflinecustomsysmsgs: this.onOfflineCustomSysMsgs,
				oncustomsysmsg: this.onCustomSysMsg,
				// 同步完成
				onsyncdone: this.onSyncDone,
				onpushevents: this.onPushEvents,
			});
			// this.dataList = this.dataList;
			this.$forceUpdate();

			const uaParser = new UAParser();
			const browser = uaParser.getBrowser();
			this.showSendImage = !(browser.name === "IE" && browser.major <= 9);
		},
		/**
		 * 订阅事件
		 * @param param 参数
		 */
		onPushEvents(param) {
			const events = param.msgEvents.filter(me => me.type === "1").map(res => {
				return {
					"accid": res.account,
					"isOnline": res.value === "1",
				}
			});
			if (!window.onlineInfo) {
				window.onlineInfo = {};
				window.lastOnlineInfo = {};
			}
			Object.assign(window.onlineInfo, _.keyBy(events, "accid"));

			if (this.hasService) {
				this.deCheckCsrIsOffline();
			}
		},
		onConnect(e) {
			this.offline.show = false;
		},
		getUserDone(error, user) {
			this.dataList.myInfo = user;
		},
		onWillReconnect(obj) {
			this.offline.show = true;
			this.offline.title = `当前账号已掉线，正在尝试重新连接(${obj.retryCount}次)`;
		},
		onDisconnect(error) {
			console.warn("断开", error);
			// 此时说明 SDK 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
			this.offline.show = true;
			if (error) {
				switch (error.code) {
					// 账号或者密码错误, 请跳转到登录页面并提示错误
					case 302:
						this.offline.title = "云信账号密码错误，请联系管理员";
						break;
					// 重复登录, 已经在其它端登录了, 请跳转到登录页面并提示错误
					case 417:
						this.offline.title = "当前存在其他账号同时登录，您已下线";
						break;
					// 被踢, 请提示错误后跳转到登录页面
					case "kicked":
						this.offline.title = "当前存在其他账号同时登录，您已下线";
						break;
					default:
						this.offline.title = `当前会话已掉线，请检查网络并重新开启会话(${error.code})`;
						break;
				}
			}
		},
		onError(error, obj) {
		},
		// 接收消息
		onMsg(msg) {
			console.log("收到的消息", msg);
			if (msg.type === "custom" && JSON.parse(msg.content).type === "close") {
				this.delTalk("customer");
			} else if (
				msg.type === "custom" &&
				JSON.parse(msg.content).type === "force_close") {
				this.delTalk("customer");
				return;
			} else if (
				msg.type === "custom" &&
				JSON.parse(msg.content).type === "rate") {
				this.showRate = true;
			} else if (
				msg.type === "custom" &&
				JSON.parse(msg.content).type === "overtime_close") {
				this.delTalk("customer");
				return;
			}
			blink("【您有新消息】索思医疗售后集成咨询", "【█████】索思医疗售后集成咨询", "索思医疗售后集成咨询");
			if (!document.hasFocus()) {
				showNotification("您有一条新消息");
			}
			if (msg.from === this.curUser.userAccid.toLowerCase()) {
				msg.from = msg.from.toLowerCase();
				if (msg.type !== "custom") {
					this.sessionsList.push(msg);
				}
				if (!this.lastMsg || (msg.time - this.lastMsg.time) > 180000) {
					this.lastMsg = msg;
				}
				let sessionsListStr = JSON.stringify(this.sessionsList);
				sessionsListStr = Base64.encode(sessionsListStr);
				localStorage.setItem("sessions", sessionsListStr);
				this.scrollBottom();
			} else if (msg.from === this.curUserInfo.accid) {
				if (msg.type !== "custom") {
					this.sessionsList.push(msg);
				}
				this.scrollBottom();
			}
		},
		onFriends(friends) {
		},
		// 初始化会话列表
		onSessions(sessions) {
			console.log(sessions);
		},
		onUpdateSession(session) {
			console.log(session);
		},
		sendMsgReceiptDone(error, obj) {
			console.log("发送消息已读回执" + (!error ? "成功" : "失败"), error, obj);
		},
		updateSessionsUI() {
			// 刷新界面
		},
		onMyInfo(user) {
			// console.log("收到我的名片", user);
		},
		onUpdateMyInfo(user) {
		},
		onUsers(users) {
			// console.log('收到用户名片列表', users);
			// this.dataList.users = this.nim.mergeUsers(this.dataList.users, users);
			// this.dataList = this.dataList
			// this.$forceUpdate()
		},
		updateMyInfoUI() {
		},
		onSyncDone() {
			this.cloudServiceInfo();
		},
		onSysMsg(sysMsg) {
			console.log("收到系统通知", sysMsg);
			if (sysMsg.type === "deleteMsg" && sysMsg.status === "success") {
				const msgId = sysMsg.deletedIdServer;
				const msgIndex = this.sessionsList.findIndex(x => x.idServer === msgId);
				if (msgIndex >= 0) {
					this.sessionsList.splice(msgIndex, 1);
				}
			}
			let sessionsListStr = JSON.stringify(this.sessionsList);
			sessionsListStr = Base64.encode(sessionsListStr);
			localStorage.setItem("sessions", sessionsListStr);
		},
		pushMsg(msgs) {
			if (!Array.isArray(msgs)) {
				msgs = [msgs];
			}
			const sessionId = msgs[0].sessionId;
			data.msgs = data.msgs || {};
			data.msgs[sessionId] = this.nim.mergeMsgs(data.msgs[sessionId], msgs);
		},
		// 发送消息
		sendText() {
			if (checkNotificationStatus() === undefined) {
				requestNotifyPermission();
			}
			if (!this.hasService) {
				return;
			}
			if (this.chatValue === "") {
				alert("消息不能为空");
				return;
			}
			this.showEmoji = false;
			const msg = this.nim.sendText({
				scene: "p2p",
				to: this.curUser.userAccid,
				text: this.chatValue,
				done: this.sendMsgDone,
			});
			sendMsgToServerCheckOverTime({
				sessionIdStr: this.curUser.sessionId,
			}).then();
		},
		sendMsgDone(error, msg) {
			console.log("sendMsgDone", msg);
			this.nim.sendMsgReceipt({
				msg: msg,
				done: this.sendMsgReceiptDone,
			});
			if (!this.lastMsg || (msg.time - this.lastMsg.time) > 180000) {
				this.lastMsg = msg;
			}
			this.chatValue = "";
			msg.from = msg.from.toLowerCase();
			if (msg.type !== "custom") {
				this.sessionsList.push(msg);
			}
			if (!this.delTalkFlag) {
				let sessionsListStr = JSON.stringify(this.sessionsList);
				sessionsListStr = Base64.encode(sessionsListStr);
				localStorage.setItem("sessions", sessionsListStr);
				this.scrollBottom();
			}
		},
		/**
		 * 获取历史消息
		 * @param options 消息内容
		 * @returns {Promise<unknown>}
		 */
		getHistoryP2PMsgs(options) {
			return new Promise((ret, rej) => {
				options = Object.assign({
					"scene": "p2p",
					"done"(error, obj) {
						if (error) {
							rej(error);
						} else {
							ret(obj);
						}
					},
				}, options);
				this.nim.getHistoryMsgs(options);
			});
		},

		getHistoryMsgsDone(error, obj) {
			this.sessionsList = obj.msgs;
			this.scrollBottom();
		},

		scrollBottom() {
			this.$nextTick(() => {
				const chatWrap = document.getElementById("chatWrap");
				chatWrap.scrollTop = chatWrap.scrollHeight;
			});
		},
		/**
		 * 预览图片
		 * @param url
		 */
		goImgUrl(url) {
			window.open(url, "_blank");
		},
		/**
		 * 下载文件
		 * @param file
		 */
		goFile(file) {
			const link = document.createElement("a");
			link.style.display = "none"; // 创建一个隐藏的a标签
			link.href = file.url + "&download=" + file.name;
			document.body.appendChild(link);
			link.click(); // 触发a标签的click事件
			document.body.removeChild(link);
		},
		/**
		 * 选择文件
		 */
		handleSendFile() {
			this.showEmoji = false;
			document.getElementById("fileselect").click();
		},
		/**
		 * 获取上传状态提示
		 * @param prog
		 */
		getProgressText(prog) {
			let loaded = sizeFormat(prog.loaded);
			let total = sizeFormat(prog.total);
			return () => `${prog.fileName}(${loaded} / ${total}) : ${prog.percentage}%`;
		},
		/**
		 * 发送文件
		 */
		uploadFile() {
			this.showEmoji = false;
			const fileSelect = document.getElementById("fileselect");
			let localFile;
			let type;
			const types = ["image", "video", "audio"];
			if (fileSelect.files) {
				localFile = fileSelect.files[0];
			} else {
				localFile = {
					"type": "file",
					"name": "上传文件",
				}
			}
			const findType = types.find(x => localFile.type.includes(x));
			type = findType ?? "file";
			const progress = {
				id: _.uniqueId(),
				total: 0,
				loaded: 0,
				percentage: 0,
				fileName: localFile.name,
			};
			this.progressFiles.push(progress);
			this.nim.sendFile({
				scene: this.scene,
				to: this.curUser.userAccid,
				fileInput: fileSelect,
				type: type,
				uploadprogress: (obj) => {
					progress.total = obj.total;
					progress.loaded = obj.loaded;
					progress.percentage = obj.percentage;
				},
				uploaddone: (error, file) => {
					progress.loaded = progress.total;
					setTimeout(() => {
						const index = this.progressFiles.findIndex(x => x === progress);
						if (index >= 0) {
							this.progressFiles.splice(index, 1);
						}
					}, 2000);
				},
				beforesend: function (msg) {

				},
				done: this.sendMsgDone,
			});
		},
		reLinkService() {
			this.cloudServiceInfo();
		},
		// 结束聊天
		delTalk(type) {
			if (type === "customer") {
				this.delTalkFlag = true;
				this.hasService = false;
				this.curUser = {
					"userAccid": "",
				};
				//this.sessionsList = [];
				localStorage.clear();
			} else if (this.curUser.sessionId) {
				const storageId = `session-${this.curUser.sessionId}`;
				close({ sessionIdStr: this.curUser.sessionId }).then((res) => {
					if (res.code === 200) {
						this.delTalkFlag = true;
						let content = {
							type: "close",
							sessionId: this.curUser.sessionId,
						};
						content = JSON.stringify(content);
						const msgId = this.nim.sendCustomMsg({
							scene: "p2p",
							to: this.curUser.userAccid,
							content: content,
							sendToOnlineUsersOnly: true,
							apnsText: content,
							done: this.sendMsgDone,
						});
						const sessionId = this.curUser.sessionId;
						const userAccid = this.curUser.userAccid;
						this.hasService = false;
						this.curUser = {};
						//this.sessionsList = [];
						addBatch(this.nim.account, userAccid, sessionId);
						localStorage.removeItem(storageId);
					}
				});
			} else {
				this.delTalkFlag = true;
				this.hasService = false;
				this.curUser = {};
				//this.sessionsList = [];
				localStorage.clear();
			}
		},
		devareLocalSessionDone(error, obj) {
			this.curUser = {};
			this.nim.setCurrSession("");
			this.nim.getLocalSessions({
				limit: 100,
				done: this.getLocalSessionsDone,
			});
		},
		getLocalSessionsDone(error, obj) {
			// console.log("获取本地会话列表" + (!error ? "成功" : "失败"), error, obj);
			if (!error) {
				this.dataList.sessions = [];
				this.sessionsList = [];
				this.onSessions(obj.sessions);
			}
		},
		// 点击emoji
		handleClickEmoji(icon) {
			const elInput = document.getElementById("chatInput");
			const startPos = elInput.selectionStart;
			const endPos = elInput.selectionEnd;
			if (this.chatValue.length !== endPos) {
				if (startPos === undefined || endPos === undefined) return;
				const txt = elInput.value;
				const result = txt.substring(0, startPos) + icon + txt.substring(endPos);
				this.chatValue = result;
				elInput.focus();
				elInput.selectionStart = startPos + icon.length;
				elInput.selectionEnd = startPos + icon.length;
			} else {
				this.chatValue = this.chatValue + icon;
			}
		},
		handleClickInput() {
			this.showEmoji = false;
		},
		goNewImg(url) {
			window.open(url);
		},
		filterCustom(content) {
			const data = JSON.parse(content);
			if (data.type === "rate") {
				return "对方邀请您对此次咨询进行评价";
			} else if (data.type === "close") {
				return "关闭会话";
			}
		},
		// 客户主动评价
		handleUserRate() {
			checkRateRes({ sessionIdStr: this.curUser.sessionId }).then((res) => {
				if (res.code === 200) {
					this.rateRes = res.data;
					if (
						this.rateRes.sessionScore === null &&
						this.rateRes.status === "0"
					) {
						this.showRate = true;
					} else {
						alert("当前会话已评价，感谢您的支持！");
					}
				}
			});
		},
		contextmenu1(i) {
			console.log(i);
			this.delMsgIndex = i;
			//右键单击事件
			event.preventDefault();
			const x = event.clientX;
			const y = event.clientY;
			// Get the current location
			this.contextMenuData1.axis = {
				x,
				y,
			};
			this.$refs.contextMenu.open();
		},
		// 撤回
		delMsg() {
			if (!this.hasService) {
				return;
			}
			const msg = this.sessionsList[this.delMsgIndex];
			if (msg.from === this.curUser.to) {
				alert("无法撤回对方消息");
				return;
			} else {
				this.nim.deleteMsg({
					msg: msg,
					done: this.deleteMsgDone,
				});
			}
		},
		deleteMsgDone(error) {
			if (!error) {
				// 撤回删除会话中的一条
				this.sessionsList.splice(this.delMsgIndex, 1);
			} else {
				const errorArr = error.message.split(":");
				alert("已超撤回时效，无法撤回");
			}
		},
		/**
		 * 获取消息中的设备id
		 * @param msg
		 */
		getMsgDeviceId(msg) {
			const deviceId = msg.fromDeviceId;
			if (deviceId && deviceId.length > 8) {
				return `用户(${deviceId.substr(0, 8)})&nbsp;`;
			}
			return "";
		},
		/**
		 * 分析时间
		 * @param timestamp
		 */
		parseTime(timestamp) {
			return moment(timestamp).format("YYYY-MM-DD HH:mm:ss");
		},
	},
	"components": {
		"vue-context-menu": vueContextMenu,
	},
};
</script>

<style lang="scss" scoped>
.app-container {
	display: flex;

	.center_part {
		width: 624px;
		margin: 40px auto 0;
		position: relative;

		.logo {
			img {
				width: 184px;
				height: 52px;
			}
		}

		.serviceInfo {
			margin-top: 30px;
			margin-bottom: 20px;

			img {
				width: 90px;
				height: 90px;
			}

			.serviceInfo_left {

				> div {
					padding-top: 10px;
					margin-left: 10px;
				}
			}
		}

		.rateDialog {
			width: 474px;
			height: 387px;
			background: #fff;
			position: absolute;
			top: 226px;
			left: 0;
			right: 0;
			margin: auto;
			z-index: 99999;
			box-shadow: 0 0 10px #999999;
			padding-top: 38px;

			.cancel {
				position: absolute;
				top: 0;
				right: 0;
				width: 45px;
				height: 27px;
				background: #df0000;
				text-align: center;
				line-height: 27px;
				color: #fff;
			}

			.cancel:hover {
				cursor: pointer;
			}

			.rateTitle {
				font-size: 20px;
				font-weight: 500;
				color: #2697a2;
				text-align: center;
				margin-bottom: 30px;
			}

			.rateTip {
				font-size: 14px;
				color: #535353;
				text-align: center;
			}

			.rateBox {
				margin-top: 36px;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.rateContent {
				margin: 56px auto 32px;
				width: 380px;
			}
		}

		.chatWrap {
			width: 100%;
			height: 440px;
			border: 1px solid #b2b2b2;
			border-radius: 4px;
			overflow-y: auto;
			position: relative;

			.waitTip {
				text-align: center;
				position: sticky;
				top: 10px;
				left: 0;
				right: 0;
				color: #999999;
				z-index: 1212;
				font-size: 14px;
			}

			.chatItem {
				padding: 10px;

				> div {
					width: 90%;

					img {
						width: 40px;
						height: 40px;
						border-radius: 12px;
					}
				}

				.chatIn {

					.chatContent {
						margin-left: 14px;
						background: #eeeeee;
						font-size: 14px;
						color: #262626;
						border-radius: 6px;
						padding: 5px 15px;
						position: relative;

						.sanjiao {
							position: absolute;
							left: -8px;
							top: 15px;
							width: 0;
							height: 0;
							border-top: 5px solid transparent;
							border-right: 10px solid #eeeeee;
							border-bottom: 5px solid transparent;
						}

						.chatImg:hover {
							cursor: pointer;
						}

						.time {
							font-size: 12px;
							color: #b8b8b8;
							position: absolute;
							width: 200px;
							left: 0;
							top: -16px;
						}
					}
				}

				.chatOut {
					height: 100%;

					.chatContent {
						margin-right: 14px;
						background: #9eea6a;
						font-size: 14px;
						color: #262626;
						border-radius: 6px;

						padding: 5px 15px;
						position: relative;

						.sanjiao {
							position: absolute;
							right: -8px;
							top: 15px;
							width: 0;
							height: 0;
							border-top: 5px solid transparent;
							border-left: 10px solid #9eea6a;
							border-bottom: 5px solid transparent;
						}

						.chatImg:hover {
							cursor: pointer;
						}

						.time {
							font-size: 12px;
							color: #b8b8b8;
							position: absolute;
							width: 300px;
							right: 0;
							top: -14px;
							text-align: right;
						}
					}
				}
			}
		}

		.chatInStyle {
			display: flex;
			justify-content: flex-start;
		}

		.chatOutStyle {
			display: flex;
			justify-content: flex-end;
		}

		.files {
			padding: 6px;
			display: flex;
			flex-direction: column;
		}

		.chatFunBtn {
			width: 100%;
			height: 40px;
			line-height: 40px;
			display: flex;
			align-items: center;
			position: relative;

			img {
				margin-right: 16px;
			}

			img:hover {
				cursor: pointer;
			}

			.fileselect {
				display: none;
			}

			.emojiWrap {
				height: 180px;
				width: 360px;
				position: absolute;
				overflow: auto;
				background: #fff;
				top: -178px;
				border: 1px solid #b2b2b2;
				border-radius: 4px;
				box-shadow: gainsboro 1px 1px 1px;

				.emojiItem {
					font-size: 20px;
				}
			}
		}

		.chatInputWrap {
			.chatInputInput {
				width: calc(100% - 120px);
			}
		}
	}

	.right_part {
		width: calc(100% - 970px);

		.noticeWrap {
			height: 700px;
			overflow: auto;

			.noticeItem {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 10px 0;
				border-bottom: 1px solid #eeeeee;

				.noticeItem_left {
					.noticeTitle {
						font-size: 14px;
						color: #333333;
						margin-bottom: 5px;
					}

					.noticeTime {
						font-size: 12px;
						color: #999999;
					}
				}
			}
		}

		.replyWrap {
			height: 700px;

			.replyItem {
				margin-bottom: 8px;
				font-size: 14px;
				color: #505050;

				> div:first-of-type {
					margin-bottom: 4px;
				}

				> div:nth-of-type(2) {
					text-indent: 1.3em;
				}

				> div:nth-of-type(2):hover {
					cursor: pointer;
				}

				.replyItemClick:hover {
					cursor: pointer;
				}
			}
		}

		.orderWrap {
			.center_part_tabsChange {
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				margin-bottom: 10px;

				.tabsChangeItem {
					width: 105px;
					height: 30px;
					background: #ffffff;
					border: 1px solid #999999;
					opacity: 1;
					border-radius: 17px;
					line-height: 30px;
					text-align: center;
					margin-bottom: 10px;
					font-size: 14px;
					margin-right: 14px;
				}

				.tabsChangeItem:hover {
					cursor: pointer;
				}

				.selectTbas {
					border: 1px solid #2697a2;
					color: #2697a2;
				}

				.spStyle {
					margin-right: 0px;
				}
			}
		}

		.historyWrap {
			.historyWrap_top {
				margin-top: 10px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 10px;

				> div {
					font-size: 14px;
					color: #b8b8b8;
				}

				> div:hover {
					cursor: pointer;
				}
			}

			.history {
				display: flex;
				flex-wrap: wrap;
				margin-bottom: 10px;

				.historyItem {
					padding: 5px 10px;
					font-size: 14px;
					color: #b8b8b8;
					background: #f1f1f1;
					border-radius: 30px;
					margin: 0 20px 10px 0;
				}

				.historyItem:hover {
					cursor: pointer;
				}
			}

			.zhishi {
				height: 600px;

				.zhishiItem {
					display: flex;
					align-items: center;
					padding: 10px 0;
					border-bottom: 1px solid #eeeeee;

					img {
						width: 26px;
						height: 33px;
						margin-right: 10px;
					}
				}

				.zhishiItem_right {
					.zhishiItemTitle {
						font-size: 14px;
						color: #333333;
						margin-bottom: 4px;
					}

					.zhishiItemTime {
						span {
							font-size: 12px;
							color: #999999;
							margin-right: 18px;
						}
					}
				}
			}
		}
	}
}

::-webkit-scrollbar {
	display: none;
}

.chatRecordWrap {
	height: 600px;
	overflow: auto;

	.chatImg {
		width: 100px;
		height: 100px;
		margin-right: 5px;
	}

	.chatImg:hover {
		cursor: pointer;
	}

	.chatRecordTxtItem {
		margin-bottom: 10px;

		.txtInfo {
			font-size: 14px;
			color: #262626 !important;
			margin-bottom: 3px;

			span {
				color: #7d7d7d;
			}
		}

		.cusTomerStyle {
			font-size: 14px;
			color: #59c6ce;
		}

		.serviceStyle {
			font-size: 14px;
			color: #feaa61;
		}
	}

	.chatRecordFile {
		padding: 5px 0;
		border-bottom: 1px solid #dddddd;
		display: flex;

		.chatFileInfo {
			display: flex;
			flex-direction: column;
			margin-left: 6px;
			justify-content: space-around;

			span {
				display: block;
				font-size: 14px;
				color: #ababab;
			}
		}
	}
}

.send-btn {
	min-width: 100px;
}

.menu-item {
	padding: .125rem .25rem;
	user-select: none;
	cursor: pointer;
}
</style>

<style>
.el-tabs__nav-wrap::after {
	background: #fff !important;
}

.el-rate__icon {
	font-size: 50px;
}

.vue-contextmenu-listWrapper {
	padding: 0;
	background: #eeeeee !important;
}

.no-child-btn {
	height: 26px !important;
	background: #eeeeee !important;
	display: flex;
	align-items: center;
	justify-content: center;
}

.nav-name-right {
	line-height: 20px !important;
}

.vs_char_view_time {
	margin-bottom: .5rem;
}

.chatOutStyle .vs_char_view_time {
	text-align: right;
}

.chat-notify {
	flex: 1 1 auto;
	min-width: 0;
	min-height: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: .75rem;
	color: #999999;
}
</style>
